// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3TPfr","amount":"Amount_amount__Bgpkm","tip":"Amount_tip__3uL9l","tipHeader":"Amount_tipHeader__2Dp7u","tipsWrap":"Amount_tipsWrap__1sggN"};